import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import { localApi, credentials, localApib2b } from "utils/imgApi";
import { dataURLtoFile } from "utils/dataURLToFile";
import { BiEdit } from "react-icons/bi";
import Compressor from "compressorjs";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import PropTypes from "prop-types";
import Axios from "axios";
import CardAvatar from "components/Card/CardAvatar.js";
import defaultAvatar from "assets/img/placeholder.jpg";
import defaultImage from "assets/img/image_placeholder.jpg";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import styleDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import styleBtn from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const style = {
    cardTitle,
    pageSubcategoriesTitle: {
        color: "#3C4858",
        textDecoration: "none",
        textAlign: "center",
    },
    cardCategory: {
        margin: "0",
        color: "#999999",
    },
};

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleDrop = makeStyles(styleDrop);
const useStyleSweet = makeStyles(styleSweet);
const useStyleBtn = makeStyles(styleBtn);

export default function ImagesAddSign(props) {
    const [signImg, setSignImg] = React.useState("");
    const [logoImg, setLogoImg] = React.useState("");
    const [firstname, setFristname] = React.useState("");
    const [lastname, setLastname] = React.useState("");
    const [submittedSign, setSubmittedSign] = React.useState(false);
    const [submittedDeleteSign, setSubmittedDeleteSign] = React.useState(false);
    const [userData, setUserData] = React.useState({});
    const [type, setType] = React.useState("");

    const [items, setItems] = React.useState([]);
    const [items1, setItems1] = React.useState([]);
    const [simpleSelect, setSimpleSelect] = React.useState("");
    const [simpleSelectErr, setSimpleSelectErr] = React.useState("");
    const [simpleSelect1, setSimpleSelect1] = React.useState("");
    const [simpleSelect1Err, setSimpleSelect1Err] = React.useState("");
    const [checkedFullSize, setCheckedFullSize] = React.useState(false);
    const [getId, setGetId] = React.useState("");
    const [getcatId, setGetcatId] = React.useState("");
    const [submitted, setSubmitted] = React.useState(false);
    const [alertType, alertTypeOps] = React.useState("");
    const [alertMsg, alertMsgOps] = React.useState("");

    const [newImage, setNewImage] = React.useState(false);
    const [btn, setBtn] = React.useState(false);

    const classes = useStyles();
    const classe = useStyle();
    const classDrop = useStyleDrop();
    const history = useHistory();
    const classSweet = useStyleSweet();
    const classBtn = useStyleBtn();

    const { search } = useLocation();
    const a = new URLSearchParams(search).get("a");

    const [file, setFile] = React.useState(null);
    const [fileErr, setFileErr] = React.useState(null);
    const [crop, setCrop] = React.useState({
        aspect: 1,
        unit: "px",
        width: 76, //280
        height: 76, //336
    });
    const [image, setImage] = React.useState("");
    const [result, setResult] = React.useState("");
    const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
        props.avatar ? "" : ""
    );
    let fileInput = React.createRef();
    let fileInputSign = React.createRef();
    const handleImageChange = (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            setFile(file);
            setImagePreviewUrl(reader.result);
        };
        if (file) {
            reader.readAsDataURL(file);
        }
        setFileErr("");
    };

    const getCroppedImg = () => {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        const base64Image = canvas.toDataURL("image/jpeg");
        setResult(base64Image);
    };

    const handleClick = () => {
        fileInput.current.click();
    };

    const handleRemove = () => {
        setFile(null);
        setImagePreviewUrl(props.avatar ? "" : "");
        fileInput.current.value = null;
    };

    let { avatar, addButtonProps, changeButtonProps, removeButtonProps } = props;

    async function getCat() {
        const api = localApib2b + `/admin/byId/${a}`;
        const result = await fetch(api, {
            method: "GET",
            headers: {
                Authorization: `Basic ${credentials}`,
            },
        });
        const getResult = await result.json();
        setUserData(getResult);
        setFristname(getResult.firstname);
        setLastname(getResult.lastname);
        setSignImg(getResult.signatureUrl + "?id=" + getResult.id);
        setLogoImg(getResult.logoUrl + "?id=" + getResult.id);

        const apiType = localApib2b + `/type/list`;
        const resultType = await fetch(apiType, {
            method: "GET",
            headers: {
                Authorization: `Basic ${credentials}`,
            },
        });
        const getResultType = await resultType.json();
        const typeDes = getResultType.TypeList.filter((f) => f.typeId === getResult.typeId)[0];
        setType(typeDes);
    }

    useEffect(() => {
        getCat();
        // catApi().then((res) => setItems(res));
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // console.log(file);
        const convertedUrlToBlob = dataURLtoFile(
            file ? result : null,
            `${file && file.name}`
        );
        // console.log(convertedUrlToBlob);
        let fData = new FormData();
        fData.append("signImage", convertedUrlToBlob || new File([""], ""));
        Axios.put(
            localApib2b + `/admin/update/signature/findById/${2}`,
            fData,
            {
                headers: {
                    Authorization: `Basic ${credentials}`,
                },
            }
        ).then((data) => {
            // console.log(data.data);
            if (data.data.message === "Data Updated Successfully !!!") {
                alertTypeOps("success");
                alertMsgOps("Succesfully !!!");
                setSubmittedSign(true);
            }
            // window.location.reload(false);
        });
        // file is the file/image uploaded
        // in this function you can save the image (file) on form submit
        // you have to call it yourself
    };

    const SubmitDeleteSignature = () => {
        // setBtn(true);
        fetch(localApib2b + `/admin/update/deleteSignature/findById/${2}`, {
            method: "PUT",
            headers: {
                Authorization: `Basic ${credentials}`,
            },
        })
            .then((res) => res.json())
            .then((res) => {
                // console.log(res);
                if (res.message === "Data Updated Successfully !!!") {
                    alertTypeOps("success");
                    alertMsgOps("Succesfully !!!");
                    setSubmittedDeleteSign(true);
                }
            });
    };

    const hideAlertSign = () => {
        setSubmittedSign(false);
        window.location.reload(false);
    };

    const hideAlertDeleteSign = () => {
        setSubmittedDeleteSign(false);
        window.location.reload(false);
    };

    return (
        <div className={classes.container}>
            {submittedSign ? (
                <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlertSign()}
                    confirmBtnCssClass={classSweet.button + " " + classSweet.success}
                >
                    Updated Signature
                </SweetAlert>
            ) : null}
            {submittedDeleteSign ? (
                <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlertDeleteSign()}
                    confirmBtnCssClass={classSweet.button + " " + classSweet.success}
                >
                    Delete Signature
                </SweetAlert>
            ) : null}
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                    <Card profile>
                        <CardAvatar profile>
                            <a href="#pablo" onClick={(e) => e.preventDefault()}>
                                {/* <img src={image ? image : defaultAvatar} alt="..." /> */}
                                <img src={signImg} alt="..." />
                            </a>
                        </CardAvatar>
                        <CardBody profile>
                            <h5 className={classBtn.cardCategory}>
                                {/* CEO / CO-FOUNDER */}
                                {type.descType}
                            </h5>
                            <h3 className={classBtn.cardTitle}>
                                {firstname + "  " + lastname}
                            </h3>
                            <p className={classBtn.description}>
                                In this ever-changing society, the most powerful and enduring
                                brands are built from the heart. They are real and sustainable.
                                Their foundations are stronger because they are built with the
                                strength of the human spirit. Don’t limit yourself. Many people
                                limit themselves to what they think they can do. You can go as
                                far as your mind lets you. What you believe, remember, you can
                                achieve.
                            </p>

                            <legend>
                                My Signature Image*
                                <br /> Signature dimension Must be 76x76
                            </legend>
                            <div className="fileinput text-center">
                                <input
                                    type="file"
                                    onChange={handleImageChange}
                                    ref={fileInput}
                                />

                                {file && (
                                    <div xs={12} sm={12} md={12}>
                                        <ReactCrop
                                            src={imagePreviewUrl}
                                            onImageLoaded={setImage}
                                            crop={crop}
                                            onChange={setCrop}
                                            minWidth={76 < 76 ? 76 : 76}
                                            minHeight={76 < 76 ? 76 : 76}
                                        />
                                        <Button color="rose" round onClick={getCroppedImg}>
                                            {" "}
                                            Crop Image
                                        </Button>
                                    </div>
                                )}

                                <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
                                    {result && (
                                        <img src={result} alt="..." style={{ height: "76px" }} />
                                    )}
                                </div>
                                <div>
                                    {file === null ? (
                                        <Button
                                            color="rose"
                                            round
                                            {...addButtonProps}
                                            onClick={() => handleClick()}
                                        >
                                            {avatar ? "Select Sign" : "Select Sign"}
                                        </Button>
                                    ) : (
                                        <span>
                                            <Button
                                                round
                                                color="rose"
                                                {...changeButtonProps}
                                                onClick={() => handleClick()}
                                            >
                                                Change
                                            </Button>
                                            {avatar ? <br /> : null}
                                            <Button
                                                color="rose"
                                                round
                                                {...removeButtonProps}
                                                onClick={() => handleRemove()}
                                            >
                                                <i className="fas fa-times" /> Remove
                                            </Button>
                                            {result ? (
                                                <Button color="rose" round onClick={handleSubmit}>
                                                    upload Sign
                                                </Button>
                                            ) : (
                                                ""
                                            )}
                                        </span>
                                    )}
                                    {file ? (
                                        ""
                                    ) : (
                                        <Button color="rose" round onClick={SubmitDeleteSignature}>
                                            Delete Sign
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}

ImagesAddSign.propTypes = {
    avatar: PropTypes.bool,
    addButtonProps: PropTypes.object,
    changeButtonProps: PropTypes.object,
    removeButtonProps: PropTypes.object,
};
